import React, { ComponentPropsWithRef, FC, MouseEvent } from 'react';
import { IconButton } from '@components/buttons/IconButton/IconButton.component';
import { Text } from '@components/Text/Text.component';
import { StarFavoriteIcon } from '@icons/StarFavorite.icon';
import classnames from 'classnames';
import styles from './FavoriteButton.module.scss';

type Props = Omit<ComponentPropsWithRef<'button'>, 'onClick'> & {
  isFavorite: boolean;
  withLabel?: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
};

export const FavoriteButton: FC<Props> = ({ isFavorite, withLabel = false, onClick, className, ...rest }) => {
  const rootClass = classnames('inline-flex', styles.favoriteButton, className);
  const wrapperClass = classnames(styles.favoriteWrapper);

  return (
    <IconButton className={rootClass} onClick={onClick} wrapperClassName={wrapperClass} {...rest}>
      <StarFavoriteIcon isFavorite={isFavorite} />
      {withLabel && (
        <Text
          className="plc-ml-xs"
          i18nKey={isFavorite ? 'common.added-to-favorite' : 'common.add-to-favorite'}
          tag="span"
          variant="small"
        />
      )}
    </IconButton>
  );
};
